var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingSelectList",
      "extra-items": [{
        text: _vm.bookingPreset.name,
        to: 'BookingList',
        params: _vm.$route.params.id
      }, _vm.currentStepTitle]
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    class: {
      active: _vm.step == '',
      'has-checkbox': true,
      'has-checkbox--checked': _vm.bookingPreset.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('');
      }
    }
  }, [_c('a', [_vm._v("時段設定")])]), _c('li', {
    class: {
      active: _vm.step == '#limit-setting',
      'has-checkbox': true,
      'has-checkbox--checked': _vm.bookingPreset.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#limit-setting');
      }
    }
  }, [_c('a', [_vm._v("預約次數限制")])])])])]), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_vm.step == '' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-4 mb-3 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.bookingPreset.name) + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mb-3"
  }, [_c('div', {
    staticClass: "row g-2"
  }, [this.checkPermission([_vm.consts.BOOKING_SETTING_DAY_IMPORT]) && this.presetTimeField.date_condition === 'limited' ? _c('div', {
    staticClass: "col-12 col-xl-3"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-upload",
      modifiers: {
        "modal-upload": true
      }
    }],
    staticClass: "w-100",
    attrs: {
      "variant": "inverse-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-cloud-upload mr-1 me-1"
  }), _vm._v("批次匯入日期 ")])], 1) : _vm._e(), this.presetTimeField.date_condition === 'limited' ? _c('div', {
    staticClass: "col-12 col-xl-3"
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "variant": "inverse-info"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('span', {
    staticClass: "mdi mdi-cloud-download mr-1 me-1"
  }), _vm._v("匯出日期紀錄 ")])], 1) : _vm._e(), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('AppSingleSelect', {
    staticClass: "w-100",
    attrs: {
      "options": _vm.branchOptions
    },
    on: {
      "input": _vm.formatAndFetchPreset
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  })], 1)])]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約時間"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.presetTimeField.format,
      callback: function callback($$v) {
        _vm.$set(_vm.presetTimeField, "format", $$v);
      },
      expression: "presetTimeField.format"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "datetime"
    }
  }, [_vm._v("日期＋時間")]), _c('b-form-radio', {
    attrs: {
      "value": "date"
    }
  }, [_vm._v("日期")])], 1)], 1), _vm.isInclude('date', _vm.presetTimeField.format) ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "日期格式"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.presetTimeField.date_condition,
      callback: function callback($$v) {
        _vm.$set(_vm.presetTimeField, "date_condition", $$v);
      },
      expression: "presetTimeField.date_condition"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "unlimited"
    }
  }, [_vm._v("自行選擇日期")]), _c('b-form-radio', {
    attrs: {
      "value": "limited"
    }
  }, [_vm._v("特定日期")])], 1)], 1) : _vm._e(), _vm.isInclude('date', _vm.presetTimeField.format) ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "日期呈現樣式"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.form.business.date_style,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "date_style", $$v);
      },
      expression: "form.business.date_style"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("預設")]), _c('b-form-radio', {
    attrs: {
      "value": "calendar_style"
    }
  }, [_vm._v("日曆下拉")]), _c('b-form-radio', {
    attrs: {
      "value": "select_style"
    }
  }, [_vm._v("日期下拉")])], 1)], 1) : _vm._e(), _vm.presetTimeField.format == 'date' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每週行事曆"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.form.reservation_periods_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reservation_periods_enabled", $$v);
      },
      expression: "form.reservation_periods_enabled"
    }
  }, [_vm._v("啟用 ")])], 1) : _vm._e(), _vm.isInclude('datetime', _vm.presetTimeField.format) ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "時間格式"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.presetTimeField.time_condition,
      callback: function callback($$v) {
        _vm.$set(_vm.presetTimeField, "time_condition", $$v);
      },
      expression: "presetTimeField.time_condition"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "unlimited"
    }
  }, [_vm._v("自行選擇時間")]), _c('b-form-radio', {
    attrs: {
      "value": "limited"
    }
  }, [_vm._v("連續時間")]), _c('b-form-radio', {
    attrs: {
      "value": "specified"
    }
  }, [_vm._v("特定時間")])], 1)], 1) : _vm._e(), _vm.presetTimeField.format == 'datetime' && (_vm.presetTimeField.time_condition == 'limited' || _vm.presetTimeField.time_condition == 'specified') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "時間呈現樣式"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isWizard
    },
    model: {
      value: _vm.form.business.time_style,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "time_style", $$v);
      },
      expression: "form.business.time_style"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("預設")]), _c('b-form-radio', {
    attrs: {
      "value": "time_select_style",
      "disabled": true
    }
  }, [_vm._v("時間下拉")]), _c('b-form-radio', {
    attrs: {
      "value": "select_style",
      "disabled": _vm.presetTimeField.time_condition == 'unlimited'
    }
  }, [_vm._v("自訂下拉")]), _c('b-form-radio', {
    attrs: {
      "value": "button_style",
      "disabled": _vm.presetTimeField.time_condition == 'unlimited'
    }
  }, [_vm._v("內嵌時間")])], 1)], 1) : _vm._e(), _vm.presetTimeField.format == 'datetime' && _vm.presetTimeField.time_condition == 'specified' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "時段設定"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": _vm.handleDailyTimeChange
    },
    model: {
      value: _vm.form.business.daily_time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "daily_time", $$v);
      },
      expression: "form.business.daily_time"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "daily_fixed_time"
    }
  }, [_vm._v("每日固定時段")]), _c('b-form-radio', {
    attrs: {
      "value": "daily_flexible_time"
    }
  }, [_vm._v("依日期調整時段")])], 1)], 1) : _vm._e(), _vm.isInclude('date', _vm.presetTimeField.format) && _vm.presetTimeField.date_condition == 'limited' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "日期區段設定"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": _vm.changeDateConfigBy
    },
    model: {
      value: _vm.form.business.date_config_by,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "date_config_by", $$v);
      },
      expression: "form.business.date_config_by"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("預設")]), _c('b-form-radio', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("自訂")])], 1)], 1) : _vm._e(), _vm.isInclude('date', _vm.presetTimeField.format) && _vm.presetTimeField.date_condition == 'limited' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_c('VueDraggable', {
    attrs: {
      "handle": ".option-drag-handler",
      "list": _vm.form.business.options,
      "disabled": _vm.form.business.date_config_by == 'default'
    }
  }, _vm._l(_vm.form.business.options, function (option, optionIndex) {
    return _c('div', {
      key: 'date-opt-' + optionIndex,
      staticClass: "mb-3"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "flex-grow-1 flex-shrink-1 d-flex align-items-center"
    }, [_c('i', {
      staticClass: "fa fa-bars mr-3 option-drag-handler"
    }), _c('AppDatePicker', {
      attrs: {
        "disabled": _vm.form.business.date_config_by == 'default'
      },
      model: {
        value: _vm.form.business.options[optionIndex].value,
        callback: function callback($$v) {
          _vm.$set(_vm.form.business.options[optionIndex], "value", $$v);
        },
        expression: "form.business.options[optionIndex].value"
      }
    }), _c('b-form-input', {
      staticClass: "ml-2",
      staticStyle: {
        "width": "200px",
        "flex-shrink": "0"
      },
      attrs: {
        "placeholder": "請填入顯示文字",
        "disabled": _vm.form.business.date_config_by == 'default'
      },
      model: {
        value: _vm.form.business.options[optionIndex].text,
        callback: function callback($$v) {
          _vm.$set(_vm.form.business.options[optionIndex], "text", $$v);
        },
        expression: "form.business.options[optionIndex].text"
      }
    })], 1), _c('div', {
      staticClass: "flex-shrink-0"
    }, [_c('b-button', {
      staticClass: "ml-2 p-1 d-inline-flex align-items-center",
      attrs: {
        "variant": "inverse-success",
        "disabled": _vm.form.business.date_config_by == 'default'
      },
      on: {
        "click": function click($event) {
          return _vm.createOption(optionIndex);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-plus"
    }), _vm._v(" 增加 ")]), _c('b-button', {
      staticClass: "ml-2 p-1 d-inline-flex align-items-center",
      attrs: {
        "variant": "inverse-danger",
        "disabled": _vm.isOnlyOneOption() || _vm.form.business.date_config_by == 'default'
      },
      on: {
        "click": function click($event) {
          return _vm.removeOption(optionIndex);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-remove"
    }), _vm._v(" 移除 ")]), _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal",
        value: 'modal-create-date-option',
        expression: "'modal-create-date-option'"
      }],
      staticClass: "ml-2 p-1 d-inline-flex align-items-center btn-inverse-info",
      attrs: {
        "disabled": _vm.form.business.date_config_by == 'default'
      },
      on: {
        "click": function click($event) {
          _vm.dateOptionIndex = optionIndex;
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-calendar-plus"
    }), _vm._v(" 區間 ")])], 1)]), _vm.form.business.daily_time == 'daily_flexible_time' ? _c('div', {
      staticClass: "mt-2 pl-4"
    }, [_c('b-card', {
      staticClass: "shadow-none px-3 pt-3 ",
      attrs: {
        "no-body": ""
      }
    }, [_c('VueDraggable', {
      attrs: {
        "handle": ".option-drag-handler",
        "list": _vm.form.business.options.time_options,
        "disabled": _vm.form.business.date_config_by == 'default'
      }
    }, _vm._l(_vm.form.business.options[optionIndex].time_options, function (option, timeOptionIndex) {
      return _c('div', {
        key: optionIndex + '-daily-time-opt-' + timeOptionIndex,
        staticClass: "mb-3 d-flex align-items-center"
      }, [_c('div', {
        staticClass: "flex-grow-1 flex-shrink-1 d-flex align-items-center"
      }, [_c('i', {
        staticClass: "fa fa-bars mr-3 option-drag-handler"
      }), _c('AppTimePicker', {
        attrs: {
          "disabled": _vm.form.business.date_config_by == 'default'
        },
        model: {
          value: _vm.form.business.options[optionIndex].time_options[timeOptionIndex].value,
          callback: function callback($$v) {
            _vm.$set(_vm.form.business.options[optionIndex].time_options[timeOptionIndex], "value", $$v);
          },
          expression: "form.business.options[optionIndex].time_options[timeOptionIndex].value"
        }
      }), _c('b-form-input', {
        staticClass: "ml-2",
        staticStyle: {
          "width": "200px"
        },
        attrs: {
          "placeholder": "請填入顯示文字",
          "disabled": _vm.form.business.date_config_by == 'default'
        },
        model: {
          value: _vm.form.business.options[optionIndex].time_options[timeOptionIndex].text,
          callback: function callback($$v) {
            _vm.$set(_vm.form.business.options[optionIndex].time_options[timeOptionIndex], "text", $$v);
          },
          expression: "form.business.options[optionIndex].time_options[timeOptionIndex].text"
        }
      })], 1), _vm.form.business.date_config_by != 'default' ? _c('div', {
        staticClass: "flex-shrink-0"
      }, [_c('b-button', {
        staticClass: "ml-2 p-1 d-inline-flex align-items-center",
        attrs: {
          "variant": "inverse-success"
        },
        on: {
          "click": function click($event) {
            return _vm.createDailyTimeOption(optionIndex, timeOptionIndex);
          }
        }
      }, [_c('span', {
        staticClass: "mdi mdi-18px mdi-playlist-plus"
      }), _vm._v(" 增加 ")]), _c('b-button', {
        staticClass: "ml-2 p-1 d-inline-flex align-items-center",
        attrs: {
          "variant": "inverse-danger",
          "disabled": _vm.form.business.options[optionIndex].time_options.length === 1
        },
        on: {
          "click": function click($event) {
            return _vm.removeDailyTimeOption(optionIndex, timeOptionIndex);
          }
        }
      }, [_c('span', {
        staticClass: "mdi mdi-18px mdi-playlist-remove"
      }), _vm._v(" 移除 ")])], 1) : _vm._e()]);
    }), 0)], 1)], 1) : _vm._e()]);
  }), 0)], 1) : _vm._e(), _vm.presetTimeField.format == 'datetime' && _vm.presetTimeField.time_condition == 'limited' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "時間區段設定"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": _vm.changeTimeConfigBy
    },
    model: {
      value: _vm.form.business.time_config_by,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "time_config_by", $$v);
      },
      expression: "form.business.time_config_by"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("預設")]), _c('b-form-radio', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("自訂")])], 1)], 1) : _vm._e(), _vm.presetTimeField.format == 'datetime' && _vm.presetTimeField.time_condition == 'specified' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "時間區段設定"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": _vm.changeTimeConfigBy
    },
    model: {
      value: _vm.form.business.time_config_by,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "time_config_by", $$v);
      },
      expression: "form.business.time_config_by"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("預設")]), _c('b-form-radio', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("自訂")])], 1)], 1) : _vm._e(), _vm.presetTimeField.format == 'datetime' && _vm.presetTimeField.time_condition == 'specified' && _vm.form.business.daily_time == 'daily_fixed_time' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_c('div', {
    staticClass: "ml-3"
  }, [_c('VueDraggable', {
    attrs: {
      "handle": ".time-option-drag-handler",
      "list": _vm.form.business.time_options,
      "disabled": _vm.form.business.time_config_by == 'default'
    }
  }, _vm._l(_vm.form.business.time_options, function (option, optionIndex) {
    return _c('div', {
      key: optionIndex,
      staticClass: "mb-3 d-flex align-items-center"
    }, [_c('i', {
      staticClass: "fa fa-bars mr-2 time-option-drag-handler"
    }), _c('AppTimePicker', {
      staticStyle: {
        "width": "120px",
        "flex-shrink": "0"
      },
      attrs: {
        "disabled": _vm.form.business.time_config_by == 'default'
      },
      model: {
        value: _vm.form.business.time_options[optionIndex].value,
        callback: function callback($$v) {
          _vm.$set(_vm.form.business.time_options[optionIndex], "value", $$v);
        },
        expression: "form.business.time_options[optionIndex].value"
      }
    }), _c('b-form-input', {
      staticClass: "ml-2",
      staticStyle: {
        "width": "90px",
        "flex-shrink": "0"
      },
      attrs: {
        "placeholder": "請填入顯示文字",
        "disabled": _vm.form.business.time_config_by == 'default'
      },
      model: {
        value: _vm.form.business.time_options[optionIndex].text,
        callback: function callback($$v) {
          _vm.$set(_vm.form.business.time_options[optionIndex], "text", $$v);
        },
        expression: "form.business.time_options[optionIndex].text"
      }
    }), _c('div', {
      staticClass: "ml-2 d-flex flex-shrink-0"
    }, [_c('b-button', {
      staticClass: "p-1 d-inline-flex align-items-center",
      attrs: {
        "variant": "inverse-success",
        "disabled": _vm.form.business.time_config_by == 'default',
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.createTimeOption(optionIndex);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-plus"
    }), _vm._v(" 增加 ")]), _c('b-button', {
      staticClass: "ml-2 p-1 d-inline-flex align-items-center",
      attrs: {
        "variant": "inverse-danger",
        "disabled": _vm.form.business.time_options.length === 1 || _vm.form.business.time_config_by == 'default',
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.removeTimeOption(optionIndex);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-remove"
    }), _vm._v(" 移除 ")])], 1)], 1);
  }), 0)], 1)]) : _vm._e(), _vm.presetTimeField.format == 'datetime' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_vm.presetTimeField.time_condition != 'specified' ? _c('b-form-group', {
    attrs: {
      "label-cols": "4",
      "label-cols-lg": "4",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('b-tooltip', {
          attrs: {
            "target": "start-time-label",
            "placement": "top"
          }
        }, [_vm._v(" 開始接預約的時段 ")]), _c('span', {
          attrs: {
            "id": "start-time-label"
          }
        }, [_vm._v("預約開始時間 "), _c('span', {
          staticClass: "mdi mdi-help-circle-outline"
        }), _vm._v(" *")])];
      },
      proxy: true
    }], null, false, 4064694013)
  }, [_c('AppTimePicker', {
    attrs: {
      "styleType": "unlimited",
      "disabled": _vm.form.business.time_config_by == 'default'
    },
    model: {
      value: _vm.form.business.start_time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "start_time", $$v);
      },
      expression: "form.business.start_time"
    }
  })], 1) : _vm._e(), _vm.presetTimeField.time_condition != 'specified' ? _c('b-form-group', {
    attrs: {
      "label-cols": "4",
      "label-cols-lg": "4",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('b-tooltip', {
          attrs: {
            "target": "end-time-label",
            "placement": "top"
          }
        }, [_vm._v(" 最後可預約的時段 ")]), _c('span', {
          attrs: {
            "id": "end-time-label"
          }
        }, [_vm._v("最後預約時間 "), _c('span', {
          staticClass: "mdi mdi-help-circle-outline"
        }), _vm._v(" *")])];
      },
      proxy: true
    }], null, false, 517280567)
  }, [_c('AppTimePicker', {
    attrs: {
      "styleType": "unlimited",
      "disabled": _vm.form.business.time_config_by == 'default'
    },
    model: {
      value: _vm.form.business.end_time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "end_time", $$v);
      },
      expression: "form.business.end_time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.business.start_time.beforeEndTime.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1) : _vm._e(), _vm.presetTimeField.time_condition != 'specified' ? _c('b-form-group', {
    attrs: {
      "label-cols": "4",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "每個時間區段單位 *"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.form.business.time_config_by == 'default'
    },
    on: {
      "input": _vm.generateTimeOptions
    },
    model: {
      value: _vm.form.business.slot_minutes,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "slot_minutes", $$v);
      },
      expression: "form.business.slot_minutes"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "4",
      "label-cols-lg": "4",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('b-tooltip', {
          attrs: {
            "target": "reset-time-label",
            "placement": "top"
          }
        }, [_vm._v(" 店家當日休店時段，被預約的服務不會晚於此時段 ")]), _c('span', {
          attrs: {
            "id": "reset-time-label"
          }
        }, [_vm._v("當日休店時間 "), _c('span', {
          staticClass: "mdi mdi-help-circle-outline"
        }), _vm._v(" *")])];
      },
      proxy: true
    }], null, false, 2495998789)
  }, [_c('AppTimePicker', {
    attrs: {
      "styleType": "unlimited",
      "disabled": _vm.form.business.time_config_by == 'default'
    },
    model: {
      value: _vm.form.business.closing_time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "closing_time", $$v);
      },
      expression: "form.business.closing_time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.business.close_time.beforeEndTime.$invalid
    }
  }, [_vm._v(" 休店時間必須大於等於結束時間 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每週行事曆"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.form.reservation_periods_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reservation_periods_enabled", $$v);
      },
      expression: "form.reservation_periods_enabled"
    }
  }, [_vm._v("啟用 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.onTimeFieldChange
    }
  }, [_vm._v(" 重設每週時間 ")])], 1)], 1) : _vm._e(), _vm.form.reservation_periods_enabled ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "可預約時間"
    }
  }, [_c('b-table-simple', {
    attrs: {
      "responsive": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th'), _c('b-th', {
    staticClass: "text-center"
  }, [_vm._v("例行公休日")]), _c('b-th', {
    staticClass: "text-center"
  }, [_vm._v("預約開始時間")]), _c('b-th', {
    staticClass: "text-center"
  }, [_vm._v("最後預約時間")]), _c('b-th'), _c('b-th', {
    staticClass: "text-center"
  }, [_vm._v("當日休店時間")])], 1)], 1), _c('b-tbody', [_vm._l(_vm.form.reservation_periods, function (period, dayIndex) {
    return [_c('b-tr', {
      key: "reservation-day-".concat(dayIndex),
      class: dayIndex % 2 == 0 ? 'custom-table-striped' : ''
    }, [_c('b-td', {
      staticClass: "align-top",
      attrs: {
        "rowspan": period.business_hours.length
      }
    }, [_c('span', [_vm._v(_vm._s(period.display_text))])]), _c('b-td', {
      staticClass: "text-center align-top",
      attrs: {
        "rowspan": period.business_hours.length
      }
    }, [_c('b-form-checkbox', {
      on: {
        "change": function change($event) {
          return _vm.updateReservationPeriod(dayIndex, 0, 'is_official_holiday', $event);
        }
      },
      model: {
        value: period.is_official_holiday,
        callback: function callback($$v) {
          _vm.$set(period, "is_official_holiday", $$v);
        },
        expression: "period.is_official_holiday"
      }
    })], 1), _c('b-td', [_c('AppTimePicker', {
      attrs: {
        "styleType": "unlimited",
        "disabled": period.is_official_holiday
      },
      on: {
        "input": function input($event) {
          return _vm.updateReservationPeriod(dayIndex, 0, 'start_time', $event);
        }
      },
      model: {
        value: period.business_hours[0].start_time,
        callback: function callback($$v) {
          _vm.$set(period.business_hours[0], "start_time", $$v);
        },
        expression: "period.business_hours[0].start_time"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": _vm.getValidationState(dayIndex, 0, 'start_time', 'beforeEndTime')
      }
    }, [_vm._v(" 預約開始時間必須小於最後預約時間 ")])], 1), _c('b-td', [_c('AppTimePicker', {
      attrs: {
        "styleType": "unlimited",
        "disabled": period.is_official_holiday
      },
      on: {
        "input": function input($event) {
          return _vm.updateReservationPeriod(dayIndex, 0, 'end_time', $event);
        }
      },
      model: {
        value: period.business_hours[0].end_time,
        callback: function callback($$v) {
          _vm.$set(period.business_hours[0], "end_time", $$v);
        },
        expression: "period.business_hours[0].end_time"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": _vm.getValidationState(dayIndex, 0, 'end_time', 'beforeClosingTime')
      }
    }, [_vm._v(" 最後預約時間必須小於等於當日休店時間 ")])], 1), _c('b-td', [_c('b-button', {
      staticClass: "text-primary",
      attrs: {
        "variant": "link",
        "size": "lg"
      },
      on: {
        "click": function click($event) {
          return _vm.addBusinessHour(dayIndex);
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-24px mdi-plus-circle-outline"
    })])], 1), _c('b-td', {
      staticClass: "align-top",
      attrs: {
        "rowspan": period.business_hours.length
      }
    }, [_c('AppTimePicker', {
      attrs: {
        "styleType": "unlimited",
        "disabled": period.is_official_holiday
      },
      on: {
        "input": function input($event) {
          return _vm.updateReservationPeriod(dayIndex, 0, 'closing_time', $event);
        }
      },
      model: {
        value: period.closing_time,
        callback: function callback($$v) {
          _vm.$set(period, "closing_time", $$v);
        },
        expression: "period.closing_time"
      }
    })], 1)], 1), _vm._l(period.business_hours.slice(1), function (businessHour, businessHourIndex) {
      return _c('b-tr', {
        key: "reservation-day-".concat(dayIndex, "-hour-").concat(businessHourIndex + 1),
        class: dayIndex % 2 == 0 ? 'custom-table-striped' : ''
      }, [_c('b-td', {
        staticClass: "border-0 pt-0"
      }, [_c('AppTimePicker', {
        attrs: {
          "styleType": "unlimited",
          "disabled": period.is_official_holiday
        },
        on: {
          "input": function input($event) {
            return _vm.updateReservationPeriod(dayIndex, businessHourIndex + 1, 'start_time', $event);
          }
        },
        model: {
          value: businessHour.start_time,
          callback: function callback($$v) {
            _vm.$set(businessHour, "start_time", $$v);
          },
          expression: "businessHour.start_time"
        }
      }), _c('b-form-invalid-feedback', {
        attrs: {
          "state": _vm.getValidationState(dayIndex, businessHourIndex + 1, 'start_time', 'beforeEndTime')
        }
      }, [_vm._v(" 預約開始時間必須小於最後預約時間 ")])], 1), _c('b-td', {
        staticClass: "border-0 pt-0"
      }, [_c('AppTimePicker', {
        attrs: {
          "styleType": "unlimited",
          "disabled": period.is_official_holiday
        },
        on: {
          "input": function input($event) {
            return _vm.updateReservationPeriod(dayIndex, businessHourIndex + 1, 'end_time', $event);
          }
        },
        model: {
          value: businessHour.end_time,
          callback: function callback($$v) {
            _vm.$set(businessHour, "end_time", $$v);
          },
          expression: "businessHour.end_time"
        }
      }), _c('b-form-invalid-feedback', {
        attrs: {
          "state": _vm.getValidationState(dayIndex, businessHourIndex + 1, 'end_time', 'beforeClosingTime')
        }
      }, [_vm._v(" 最後預約時間必須小於等於當日休店時間 ")])], 1), _c('b-td', {
        staticClass: "border-0 pt-0"
      }, [_c('b-button', {
        staticClass: "text-danger",
        attrs: {
          "variant": "link",
          "size": "lg"
        },
        on: {
          "click": function click($event) {
            return _vm.removeBusinessHour(dayIndex, businessHourIndex + 1);
          }
        }
      }, [_c('i', {
        staticClass: "mdi mdi-24px mdi-close-circle-outline"
      })])], 1)], 1);
    })];
  })], 2)], 1)], 1) : _vm._e(), false ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "人數限制"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    on: {
      "change": _vm.generateTimeOptions
    },
    model: {
      value: _vm.form.business.limit_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.business, "limit_type", $$v);
      },
      expression: "form.business.limit_type"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "unlimit"
    }
  }, [_vm._v("不限")]), _c('b-form-radio', {
    attrs: {
      "value": "limit_by_slot"
    }
  }, [_vm._v("依時段限定")])], 1)], 1) : _vm._e(), false ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_vm._v(" 時段限定 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.business.slot_people,
      expression: "form.business.slot_people"
    }],
    staticClass: "mb-2 mr-sm-2 mb-sm-0 w-4",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.business.slot_people
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.business, "slot_people", $event.target.value);
      }, _vm.generateTimeOptions]
    }
  }), _vm._v(" 人 ")]) : _vm._e(), false && _vm.presetLimitType == 'time' && _vm.isEnabledOccupySetting && _vm.presetTimeField.format == 'datetime' && _vm.occupySetting.is_check_branch ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預覽"
    }
  }, _vm._l(_vm.form.time_options, function (timeOption, index) {
    return _c('div', {
      key: index
    }, [_c('b-form-group', {
      attrs: {
        "label-cols": "6",
        "label-cols-lg": "6",
        "label-size": "sm",
        "label": timeOption.title
      }
    }, [_c('b-form-input', {
      attrs: {
        "disabled": _vm.form.business.limit_type == 'unlimit'
      },
      model: {
        value: timeOption.value,
        callback: function callback($$v) {
          _vm.$set(timeOption, "value", $$v);
        },
        expression: "timeOption.value"
      }
    })], 1)], 1);
  }), 0) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "disabled": _vm.disabledButton,
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "disabled": _vm.disabledButton || _vm.v$.form.business.start_time.beforeEndTime.$invalid || _vm.v$.form.business.close_time.beforeEndTime.$invalid || _vm.hasReservationValidationErrors,
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.submit('time-setting');
      }
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#limit-setting' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-4 mb-3 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.bookingPreset.name) + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mb-3"
  }, [_c('AppSingleSelect', {
    staticClass: "w-100",
    attrs: {
      "options": _vm.branchOptions
    },
    on: {
      "input": _vm.formatAndFetchPreset
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.form.occupy_config.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.form.occupy_config, "enable", $$v);
      },
      expression: "form.occupy_config.enable"
    }
  }, [_vm._v(" 預約次數限制 "), _vm.occupyCustomDisabledTip ? _c('span', {
    staticClass: "ml-1 text-muted occupy-limit-tip-icon",
    attrs: {
      "id": "occupy-limit-setting-tip"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-help-circle-outline"
  })]) : _vm._e()]), _vm.occupyCustomDisabledTip ? _c('b-tooltip', {
    attrs: {
      "target": "occupy-limit-setting-tip",
      "placement": "top"
    }
  }, [_vm._v(" " + _vm._s(_vm.occupyCustomDisabledTip) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 limit-setting-radio-group",
    attrs: {
      "disabled": !_vm.form.occupy_config.enable,
      "name": "occupy-config-type"
    },
    model: {
      value: _vm.occupyTypeModel,
      callback: function callback($$v) {
        _vm.occupyTypeModel = $$v;
      },
      expression: "occupyTypeModel"
    }
  }, [_c('b-form-radio', {
    key: 'occupy-type-default',
    attrs: {
      "value": "default"
    }
  }, [_vm._v("預設")]), _c('b-form-radio', {
    key: 'occupy-type-custom',
    attrs: {
      "value": "custom",
      "disabled": !_vm.isOccupyCustomAllowed
    }
  }, [_vm._v(" 自訂 ")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "次數上限"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v("依時段設定 時段限制")]), _c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": !_vm.canEditOccupyConfig
    },
    model: {
      value: _vm.form.occupy_config.slot_people,
      callback: function callback($$v) {
        _vm.$set(_vm.form.occupy_config, "slot_people", $$v);
      },
      expression: "form.occupy_config.slot_people"
    }
  }), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("人")])], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "前台用戶顯示設定"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "該時段的預約數量已達上限",
      "disabled": !_vm.canEditOccupyConfig
    },
    model: {
      value: _vm.form.occupy_config.full_alert_text,
      callback: function callback($$v) {
        _vm.$set(_vm.form.occupy_config, "full_alert_text", $$v);
      },
      expression: "form.occupy_config.full_alert_text"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "disabled": _vm.disabledButton,
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "disabled": _vm.disabledButton || !_vm.isOccupyCustomAllowed || !_vm.form.occupy_config.enable,
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.submit('limit-setting');
      }
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e()])], 1)], 1)])]), _c('b-modal', {
    attrs: {
      "id": "modal-create-date-option",
      "title": "設定時間範圍",
      "centered": ""
    },
    on: {
      "hidden": function hidden($event) {
        ;
      },
      "ok": _vm.createOptionByCalendar
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v(" 新增 ")])];
      }
    }])
  }, [_c('form', {
    ref: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        ;
      }
    }
  }, [_c('AppDatePicker', {
    model: {
      value: _vm.optionStartDate,
      callback: function callback($$v) {
        _vm.optionStartDate = $$v;
      },
      expression: "optionStartDate"
    }
  }), _vm._v(" ~ "), _c('AppDatePicker', {
    model: {
      value: _vm.optionEndDate,
      callback: function callback($$v) {
        _vm.optionEndDate = $$v;
      },
      expression: "optionEndDate"
    }
  })], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-upload",
      "title": "上傳",
      "hide-footer": ""
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("請上傳 Excel 檔案")]), _c('div', {
    staticClass: "my-3"
  }, [_vm._v("已選擇檔案 : " + _vm._s(_vm.file ? _vm.file.name : ""))]), _c('b-form-file', {
    staticClass: "mb-3",
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": _vm.handleUploadFile
    },
    model: {
      value: _vm.file,
      callback: function callback($$v) {
        _vm.file = $$v;
      },
      expression: "file"
    }
  })], 1)]), [_c('div', {
    staticClass: "w-100 d-flex justify-content-between align-items-center"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/branch_day_import.xlsx",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" 下載範例檔案 ")]), _c('div', [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.resetFile
    }
  }, [_vm._v(" 取消 ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v(" 確認 ")])], 1)], 1)]], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }